'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _next = require('@alifd/next');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

require('./view.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var fileAcceptMap = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};

var ButtonField = (_temp = _class = function (_React$Component) {
  _inherits(ButtonField, _React$Component);

  function ButtonField() {
    _classCallCheck(this, ButtonField);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ButtonField.prototype.printContent = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var url = _ref2.url;
      var matches, fileType, subIframes, response, blob, iframe;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (url) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:
              matches = url.match(/\.(pdf|doc|docx|xls|xlsx)$/);

              if (!(!matches || !matches[1] || !fileAcceptMap[matches[1]])) {
                _context.next = 7;
                break;
              }

              console.log('未知打印格式');
              return _context.abrupt('return');

            case 7:
              fileType = fileAcceptMap[matches[1]];

              // 清理按钮下的子iframe

              subIframes = this.buttonWrapper.getElementsByTagName('iframe');

              Array.prototype.forEach.call(subIframes || [], function (i) {
                if (i && i.parentNode) {
                  i.parentNode.removeChild(i);
                }
              });

              _context.next = 12;
              return fetch(url);

            case 12:
              response = _context.sent;
              _context.next = 15;
              return response.blob();

            case 15:
              blob = _context.sent;
              iframe = document.createElement('iframe');

              iframe.setAttribute('data-id', 'iframe-print');
              iframe.frameBorder = '0';
              iframe.scrolling = 'no';
              iframe.style.display = 'none';
              iframe.src = URL.createObjectURL(new Blob([blob], { type: fileType }));
              iframe.onload = function () {
                iframe.contentWindow.print(); // 唤起打印
              };

              this.buttonWrapper.appendChild(iframe);
              _context.next = 30;
              break;

            case 26:
              _context.prev = 26;
              _context.t0 = _context['catch'](0);

              console.log('err', _context.t0);
              window.open(url, '_blank'); // 跨域或其他异常，直接新开tab打开资源

            case 30:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 26]]);
    }));

    function printContent(_x) {
      return _ref.apply(this, arguments);
    }

    return printContent;
  }();

  ButtonField.prototype.getControlProps = function getControlProps() {
    var _this2 = this;

    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$trigger = _ref3.trigger,
        trigger = _ref3$trigger === undefined ? 'onClick' : _ref3$trigger;

    var _props = this.props,
        _onClick = _props.onClick,
        __fieldProps = _props.__fieldProps,
        type = _props.type,
        iconName = _props.iconName,
        size = _props.size,
        buttonName = _props.buttonName,
        _props$disabled = _props.disabled,
        disabled = _props$disabled === undefined ? false : _props$disabled;

    var buttonType = type,
        rankType = null;
    if (type.indexOf('-') > -1) {
      buttonType = type.split('-')[1];
      rankType = type.split('-')[0];
    }
    var fieldProps = __fieldProps;
    return _extends({
      disabled: disabled,
      className: (0, _classnames2.default)({
        'vc-btn-success': rankType === 'success'
      }),
      // value: this.getValue(),
      type: buttonType,
      text: rankType === 'text',
      warning: rankType === 'warning',
      iconName: iconName,
      size: size,
      buttonName: buttonName,
      onClick: function onClick(value) {
        if ((0, _lodash.isFunction)(_onClick)) {
          _onClick({ value: _this2.formatOut(value) });
        }
      }
    }, fieldProps);
  };

  ButtonField.prototype.renderControl = function renderControl() {
    var _this3 = this;

    var commonProps = this.getControlProps();
    var _props2 = this.props,
        fieldId = _props2.fieldId,
        style = _props2.style,
        onTriggerRequest = _props2.onTriggerRequest,
        onOpenIframeModal = _props2.onOpenIframeModal,
        borderRadius = _props2.borderRadius,
        _props2$visible = _props2.visible,
        visible = _props2$visible === undefined ? true : _props2$visible,
        _props2$isInDetail = _props2.isInDetail,
        isInDetail = _props2$isInDetail === undefined ? false : _props2$isInDetail,
        tips = _props2.tips,
        $state = _props2.$state,
        _props2$allowPrint = _props2.allowPrint,
        allowPrint = _props2$allowPrint === undefined ? false : _props2$allowPrint,
        _props2$printUrl = _props2.printUrl,
        printUrl = _props2$printUrl === undefined ? '' : _props2$printUrl;

    var store = $state && $state.getRoot();
    var buttonProps = _extends({}, commonProps);
    var renderProps = {
      className: (0, _classnames2.default)('vc-form-item', 'vc-button', { 'vc-form-item-hidden': !visible || isInDetail }),
      style: style,
      'data-field-id': fieldId
    };

    return _react2.default.createElement(
      'div',
      _extends({}, renderProps, {
        ref: function ref(node) {
          _this3.buttonWrapper = node;
        }
      }),
      _react2.default.createElement(
        _next.Button,
        _extends({}, buttonProps, {
          onClick: _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    // isFunction(onTriggerRequest) && onTriggerRequest();
                    // isFunction(onOpenIframeModal) && onOpenIframeModal();
                    store && store.emitter.emit(fieldId + ':onTriggerRequest');
                    store && store.emitter.emit(fieldId + ':onOpenIframeModal');
                    _context2.t0 = allowPrint && printUrl;

                    if (!_context2.t0) {
                      _context2.next = 6;
                      break;
                    }

                    _context2.next = 6;
                    return _this3.printContent({ url: printUrl });

                  case 6:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this3);
          })),
          style: { borderRadius: borderRadius }
        }),
        buttonProps.iconName && _react2.default.createElement(_next.Icon, { type: buttonProps.iconName, className: (0, _classnames2.default)('vc-button-icon') }),
        buttonProps.buttonName,
        tips && _react2.default.createElement(
          _next.Balloon,
          { trigger: _react2.default.createElement(_next.Icon, { type: 'prompt', size: 'xs', style: { marginLeft: 6 } }), closable: false },
          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: tips } })
        )
      )
    );
  };

  ButtonField.prototype.render = function render() {
    return this.renderControl();
  };

  return ButtonField;
}(_react2.default.Component), _class.displayName = 'Button', _class.defaultProps = {
  fieldId: null
}, _class.propTypes = {
  fieldId: _propTypes2.default.string
}, _class.validators = {
  required: {
    valid: function valid(value, param) {
      return true;
    }
  }
}, _temp);
exports.default = ButtonField;
module.exports = exports['default'];